export default __webpack_public_path__ + "static/media/office.d0c8d010.jpg";